import React from 'react'
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'

import FileHistoryModal from '@/components/Modal/FileHistoryModal'
import { Box, Grid, GridItem } from '@chakra-ui/react'
import Breadcrumb from '../Breadcrumb'
import Header from '../Header'
import Sidebar from '../Sidebar'

//Redux
import { loadingOverlaySelector } from '@/stores/ui/loadingOverlaySlice'

import { uiSelector } from '@/stores/ui/uiSlice'
import ModalRoot from './ModalRoot'

const MainLayout = ({ routes }) => {
  const { sidebarShow } = useSelector(uiSelector)

  const { show: showLoadingOverlay, text: loadingText } = useSelector(loadingOverlaySelector)

  return (
    <>
      <Grid
        templateAreas={`'sidebar header' 'sidebar main'`}
        gridTemplateRows={'120px auto'}
        templateColumns="auto 1fr"
        h="calc(100vh)"
      >
        <GridItem area="sidebar" as="aside" w="full" p={0}>
          <Sidebar show={sidebarShow} />
        </GridItem>
        <GridItem area="header" zIndex="200" position={'sticky'} top="0" alignSelf={'start'} w="100%">
          <Box bg="white">
            <Header />
            <Breadcrumb routes={routes} />
          </Box>
        </GridItem>

        <GridItem as="main" area="main" w="full" overflowY={'scroll'} overflowX={'hidden'}>
          <Box>
            <Outlet />
          </Box>
        </GridItem>
      </Grid>
      <ModalRoot />
      <FileHistoryModal />
    </>
  )
}

export default MainLayout
